import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'seguridaduser'
})
export class SeguridadUSerPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if(value==null||value==""){
      return "-----"
    }
    if(value==1){
      return "Titular InPro"
    }
    if(value==2){
      return "Alterno"
    }
    if(value==3){
      return "Titular Incidentes"
    }
    return value
}

}
